import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useMemo, useRef } from "react";

import {
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Col,
  Input,
  Row,
} from "../../components/Common/AppOverlay";

import React, { useState } from "react";
import Select from "react-select";
import { SuccessNotify, ErrorNotify } from "../../shared/Alert";
import {
  getMeetingTasks,
  getEngagementList,
  getLoggedInUser,
  getUnassignedEngagementList,
  getUnGeneratedEngagementList,
  getEngagementReviewReadiness,
  deleteEngagement,
  generateEngagementInspection,
  getUsersList,
  assignEngagementDataPreparation,
} from "../../helpers/backend_helper";
import { useGridApiRef } from "@mui/x-data-grid";
import CustomDataGrid from "../../components/Common/CustomDataGrid";
import ActionMenu from "../../components/Common/ActionMenu";

import * as url from "../../helpers/url_helper";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { showLoading } from "react-global-loading";
import NewEngagementModal from "./NewEngagementModal";
import EngagementActivities from "./EngagementActivities";
import DataImportWizardPage from "../DataImport/DataImportWizardPage";
import "./EngagementList.scss";

const CURRENT_USER_FILTER = "__current_user__";

const getClientName = (row) =>
  row.client?.clientName ||
  row.client?.name ||
  row.clientName ||
  row.branchDetail?.name ||
  "—";

const getInspectionCount = (row) =>
  Number(
    row.inspectionCount ?? row.inspections?.length ?? row.reviewCount ?? 0
  );

const EngagementList = (props) => {
  const navigate = useNavigate();
  const gridApiRef = useGridApiRef();
  const [searchParams, setSearchParams] = useSearchParams();

  const [activeTab, setactiveTab] = useState(1);
  const [showTab, setShowTab] = useState(1);

  const [tasks, setTasks] = useState([]);
  const [inspectionCycleId, setInspectionCycleId] = useState(0);
  const [sendForReviewEngagement, setSendForReviewEngagement] = useState(null);
  const [engagementPendingDeletion, setEngagementPendingDeletion] =
    useState(null);
  const [reviewReadinessIssues, setReviewReadinessIssues] = useState([]);
  const [reviewReadinessLoading, setReviewReadinessLoading] = useState(false);
  const [activitiesEngagement, setActivitiesEngagement] = useState(null);
  const [
    dataPreparationAssignmentEngagement,
    setDataPreparationAssignmentEngagement,
  ] = useState(null);
  const [dataPreparationUsers, setDataPreparationUsers] = useState([]);
  const [dataPreparationAssigneeId, setDataPreparationAssigneeId] =
    useState("");
  const [dataPreparationMessage, setDataPreparationMessage] = useState("");
  const [dataPreparationUsersLoading, setDataPreparationUsersLoading] =
    useState(false);
  const [dataPreparationSaving, setDataPreparationSaving] = useState(false);
  const [newTaskOpen, setNewTaskOpen] = useState(false);
  const engagementImportOpen = searchParams.get("view") === "import";

  const setEngagementImportOpen = (open) => {
    const next = new URLSearchParams(searchParams);
    next.delete("action");
    if (open) next.set("view", "import");
    else next.delete("view");
    setSearchParams(next);
  };
  const [isEngagementMember, setIsEngagementMember] = useState(true);
  const [currentUser, setCurrentUser] = useState(null);
  const gridRequest = useRef(0);
  useEffect(
    () => () => {
      gridRequest.current += 1;
    },
    []
  );
  const [gridLoading, setGridLoading] = useState(true);
  const [gridError, setGridError] = useState("");
  const [filters, setFilters] = useState({
    workType: "all",
    industryType: "all",
    assignedTo: "all",
    inspectionCycle: "all",
    client: "all",
  });
  const [quickFilter, setQuickFilter] = useState("all");

  useEffect(() => {
    setInspectionCycleId(props.dataId);
    loadAllEngagements();
  }, [props.dataId]);

  useEffect(() => {
    getLoggedInUser().then((account) => {
      const roleName =
        account?.role?.name ||
        account?.roleName ||
        account?.userRole?.name ||
        account?.designation ||
        "";
      setCurrentUser(account);
      setIsEngagementMember(
        Number(account?.roleId) === 4 || /engagement\s+member/i.test(roleName)
      );
    });
  }, []);

  const loadData = () => {
    if (activeTab == 1) {
      loadAllEngagements();
    } else if (activeTab == 2) {
      loadUnassignedEngagements();
    } else {
      loadUngeneratedEngagements();
    }
  };

  const toggleNewTask = () => {
    setNewTaskOpen(!newTaskOpen);
  };

  const onTaskClose = () => {
    setNewTaskOpen(false);
    loadAllEngagements();
  };

  const closeEngagementImport = () => {
    setEngagementImportOpen(false);
    loadData();
  };

  const closeSendForReview = () => {
    setSendForReviewEngagement(null);
    setReviewReadinessIssues([]);
  };

  const closeDataPreparationAssignment = () => {
    setDataPreparationAssignmentEngagement(null);
    setDataPreparationUsers([]);
    setDataPreparationAssigneeId("");
    setDataPreparationMessage("");
  };

  const openDataPreparationAssignment = (engagement) => {
    setDataPreparationAssignmentEngagement(engagement);
    setDataPreparationAssigneeId(
      engagement.assignedTo ? String(engagement.assignedTo) : ""
    );
    setDataPreparationMessage("");
    setDataPreparationUsers([]);
    setDataPreparationUsersLoading(true);
    getUsersList()
      .then((res) => {
        if (!res.status)
          throw new Error(res.message || "Unable to load firm users.");
        setDataPreparationUsers(
          (res.data || []).filter(
            (user) => user.status === 1 && user.isBlocked !== 1
          )
        );
      })
      .catch((error) =>
        ErrorNotify(error.message || "Unable to load firm users.")
      )
      .finally(() => setDataPreparationUsersLoading(false));
  };

  const saveDataPreparationAssignment = () => {
    if (!dataPreparationAssignmentEngagement || !dataPreparationAssigneeId)
      return;

    setDataPreparationSaving(true);
    assignEngagementDataPreparation({
      engagementId: dataPreparationAssignmentEngagement.id,
      assignedTo: Number(dataPreparationAssigneeId),
      message: dataPreparationMessage.trim() || null,
    })
      .then((res) => {
        if (!res.status)
          throw new Error(res.message || "Unable to assign data preparation.");
        SuccessNotify("Data preparation assigned.");
        closeDataPreparationAssignment();
        loadAllEngagements();
      })
      .catch((error) =>
        ErrorNotify(error.message || "Unable to assign data preparation.")
      )
      .finally(() => setDataPreparationSaving(false));
  };

  const openSendForReview = (engagement) => {
    setSendForReviewEngagement(engagement);
    setReviewReadinessIssues([]);
    setReviewReadinessLoading(true);
    getEngagementReviewReadiness(engagement.id)
      .then((res) => {
        if (res.status) {
          setReviewReadinessIssues(Array.isArray(res.data) ? res.data : []);
        } else {
          setReviewReadinessIssues([
            res.message || "Unable to validate review readiness.",
          ]);
        }
      })
      .catch(() =>
        setReviewReadinessIssues(["Unable to validate review readiness."])
      )
      .finally(() => setReviewReadinessLoading(false));
  };

  useEffect(() => {
    const submitId = Number(searchParams.get("submit"));
    if (!submitId || !currentUser) return;
    const selected = tasks.find((item) => Number(item.id) === submitId);
    if (!selected) return;
    const next = new URLSearchParams(searchParams);
    next.delete("submit");
    setSearchParams(next, { replace: true });
    if (!isEngagementMember && !selected.isGenerated)
      openSendForReview(selected);
  }, [tasks, currentUser, isEngagementMember, searchParams, setSearchParams]);

  useEffect(() => {
    const action = searchParams.get("action");
    if (!props.dataId || !currentUser || !["create", "import"].includes(action))
      return;
    const next = new URLSearchParams(searchParams);
    next.delete("action");
    if (action === "import" && !isEngagementMember) next.set("view", "import");
    setSearchParams(next, { replace: true });
    if (isEngagementMember) return;
    if (action === "create") {
          setNewTaskOpen(true);
    }
  }, [
    props.dataId,
    currentUser,
    isEngagementMember,
    searchParams,
    setSearchParams,
  ]);

  const openReviewAssignment = (engagement) => {
    closeSendForReview();
    const targetCycleId = Number(props.dataId || engagement.inspectionCycleId);
    navigate(targetCycleId
      ? `/inspections/${targetCycleId}/engagements/${engagement.id}/preparation`
      : `/engagements/${engagement.id}/preview`);

  };

  const confirmDeleteEngagement = () => {
    if (!engagementPendingDeletion) return;

    showLoading(true);
    deleteEngagement(engagementPendingDeletion.id)
      .then((res) => {
        if (!res.status)
          throw new Error(res.message || "Unable to delete the engagement.");
        SuccessNotify("Engagement deleted.");
        setEngagementPendingDeletion(null);
        loadAllEngagements();
      })
      .catch((error) =>
        ErrorNotify(error.message || "Unable to delete the engagement.")
      )
      .finally(() => showLoading(false));
  };

  const sendForReview = () => {
    if (!sendForReviewEngagement) return;

    showLoading(true);
    generateEngagementInspection([sendForReviewEngagement.id])
      .then((res) => {
        if (res.status) {
          SuccessNotify("Engagement sent for review.");
          props.onSentForReview?.(sendForReviewEngagement);
          closeSendForReview();
          loadAllEngagements();
        } else {
          const issues = Array.isArray(res.data)
            ? res.data
            : [res.message || "Unable to send engagement for review."];
          setReviewReadinessIssues(issues);
        }
      })
      .catch((err) => {
        console.log(err);
        setReviewReadinessIssues(["Unable to send engagement for review."]);
      })
      .finally(() => showLoading(false));
  };

  const loadEngagementRows = async (fetchRows) => {
    const requestId = ++gridRequest.current;
    setGridLoading(true);
    setGridError("");
    try {
      const res = await fetchRows();
      if (requestId !== gridRequest.current) return;
      if (!res.status)
        throw new Error(res.message || "Unable to load engagements.");
      setTasks(
        (res.data || []).filter(
          (item) =>
            !props.dataId ||
            Number(item.inspectionCycleId) === Number(props.dataId)
        )
      );
      window.dispatchEvent(new Event("piers:readiness-changed"));
    } catch (error) {
      if (requestId === gridRequest.current)
        setGridError(error.message || "Unable to load engagements.");
    } finally {
      if (requestId === gridRequest.current) setGridLoading(false);
    }
  };

  const loadAllEngagements = () => loadEngagementRows(getEngagementList);

  const loadUnassignedEngagements = () =>
    loadEngagementRows(getUnassignedEngagementList);

  const loadUngeneratedEngagements = () =>
    loadEngagementRows(getUnGeneratedEngagementList);

  const reviewTemplate = (props) => {
    return (
      <div className="statustemp e-activecolor">
        {props.reviewTemplate ? (
          <span className="statustxt">
            {props.reviewTemplate.name +
              "-" +
              props.reviewTemplateVersion.versionLabel}
          </span>
        ) : (
          ""
        )}
      </div>
    );
  };

  const newEngagement = () => {
    toggleNewTask();
  };

  const clientFirmTemplate = (record) => (
    <span className="grid-client-name">
      {record.client?.clientName ||
        record.client?.name ||
        record.clientName ||
        record.branchDetail?.name ||
        "—"}
    </span>
  );

  const actionTemplate = (record) => {
    const selectAction = (actionId) => {
      if (actionId === "edit") {
        navigate(`/engagements/${record.id}/edit`);
      } else if (actionId === "delete") {
        setEngagementPendingDeletion(record);
      } else if (actionId === "activities") {
        setActivitiesEngagement(record);
      }
    };

    return (
      <div className="engagement-row-actions">
        {Number(record.inspectionCycleId) > 0 && (
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            onClick={() => navigate(`/inspections/${record.inspectionCycleId}/preview`, { state: { fromPath: "/engagements/list" } })}
            aria-label={`Preview inspection cycle for ${record.name || record.engagementNo || "engagement"}`}
          >
            Preview Cycle
          </button>
        )}
      <ActionMenu
        label={record.name || record.engagementNo || "engagement"}
        triggerClassName="engagement-list__tour-actions"
        actions={[
          ...(!isEngagementMember
            ? [
                {
                  label: "Edit",
                  icon: <i className="bx bx-pencil" />,
                  onSelect: () => selectAction("edit"),
                },
              ]
            : []),
          {
            label: "View Activities",
            icon: <i className="bx bx-history" />,
            onSelect: () => selectAction("activities"),
          },
          ...(!isEngagementMember
            ? [
                {
                  label: "Delete",
                  icon: <i className="bx bx-trash" />,
                  className: "is-danger",
                  separatorBefore: true,
                  onSelect: () => selectAction("delete"),
                },
              ]
            : []),
        ]}
      />
      </div>
    );
  };

  const getStatusCount = (pattern) =>
    tasks.filter((item) => pattern.test(item.engagementStatus?.name || ""))
      .length;
  const engagementRows = tasks;
  const currentUserId = currentUser?.id ?? currentUser?.userId;
  const hasFullEngagementVisibility = [1, 2, 3, 5, 7, 8, 9].includes(
    Number(currentUser?.roleId)
  );

  const isMyVisibleEngagement = (row) =>
    !hasFullEngagementVisibility ||
    Number(row.assignedTo) === Number(currentUserId) ||
    row.assignedUser?.fullName === currentUser?.fullName;
  const inspectionCyclesById = new Map(
    (props.inspectionCycles || []).map((cycle) => [Number(cycle.id), cycle])
  );

  const inspectionCycleLabel = (row) => {
    if (!Number(row.inspectionCycleId)) return "Unassigned";
    const cycle = inspectionCyclesById.get(Number(row.inspectionCycleId));
    if (!cycle) return `Cycle ${row.inspectionCycleId}`;
    return [cycle.projectNo, cycle.title || cycle.projectTitle || cycle.name]
      .filter(Boolean)
      .join(" — ");
  };

  const filterOptions = {
    workTypes: [
      ...new Set(
        engagementRows.map((row) => row.workType?.name).filter(Boolean)
      ),
    ],
    industries: [
      ...new Set(
        engagementRows
          .map(
            (row) =>
              row.industryType?.name ||
              row.client?.industryType?.name ||
              row.industryTypeName ||
              row.client?.industry ||
              row.client?.industryName
          )
          .filter(Boolean)
      ),
    ],
    assignees: [
      ...new Set(
        engagementRows.map((row) => row.assignedUser?.fullName).filter(Boolean)
      ),
    ],
    clients: [
      ...new Set(
        engagementRows.map(getClientName).filter((name) => name !== "—")
      ),
    ].sort(),
    inspectionCycles: [
      ...new Set(
        engagementRows
          .map((row) => Number(row.inspectionCycleId))
          .filter(Boolean)
      ),
    ]
      .map((id) => ({
        value: String(id),
        label: inspectionCycleLabel({ inspectionCycleId: id }),
      }))
      .sort((left, right) => left.label.localeCompare(right.label)),
  };

  const visibleEngagementRows = useMemo(
    () =>
      engagementRows.filter((row) => {
        const matchesQuickFilter =
          quickFilter === "all" ||
          (quickFilter === "unassigned-cycle" &&
            !Number(row.inspectionCycleId)) ||
          (quickFilter === "assigned-cycle" &&
            Boolean(Number(row.inspectionCycleId))) ||
          (quickFilter === "with-inspections" && getInspectionCount(row) > 0) ||
          (quickFilter === "without-inspections" &&
            getInspectionCount(row) === 0);

        return (
          matchesQuickFilter &&
          (filters.workType === "all" ||
            row.workType?.name === filters.workType) &&
          (filters.industryType === "all" ||
            (row.industryType?.name ||
              row.client?.industryType?.name ||
              row.industryTypeName ||
              row.client?.industry ||
              row.client?.industryName) === filters.industryType) &&
          (filters.assignedTo === "all" ||
            (filters.assignedTo === CURRENT_USER_FILTER &&
              isMyVisibleEngagement(row)) ||
            row.assignedUser?.fullName === filters.assignedTo) &&
          (filters.inspectionCycle === "all" ||
            (filters.inspectionCycle === "unassigned" &&
              !Number(row.inspectionCycleId)) ||
            String(row.inspectionCycleId) === filters.inspectionCycle) &&
          (filters.client === "all" || getClientName(row) === filters.client)
        );
      }),
    [engagementRows, filters, quickFilter, currentUser]
  );

  const totalEngagements = engagementRows.length;
  const assignedCycleCount = engagementRows.filter((row) =>
    Number(row.inspectionCycleId)
  ).length;
  const unassignedCycleCount = totalEngagements - assignedCycleCount;
  const withInspectionsCount = engagementRows.filter(
    (row) => getInspectionCount(row) > 0
  ).length;
  const withoutInspectionsCount = totalEngagements - withInspectionsCount;

  const summaryItems = [
    ["all", "bx-folder-open", "blue", "Total Engagements", totalEngagements, "All engagement records"],
    ["assigned-cycle", "bx-link", "green", "Assigned to Cycles", assignedCycleCount, "Linked to an inspection cycle"],
    ["unassigned-cycle", "bx-unlink", "orange", "Unassigned", unassignedCycleCount, "Awaiting cycle assignment"],
    ["with-inspections", "bx-check-square", "purple", "With Reviews", withInspectionsCount, "Reviews created"],
    ["without-inspections", "bx-slider", "teal", "Without Reviews", withoutInspectionsCount, "Review setup not yet started"],
  ];
  const selectedSummary = summaryItems.find(([key]) => key === quickFilter);
  const selectSummary = (value) => {
    resetFilters();
    setQuickFilter(value);
  };

  const updateFilter = (name, value) =>
    setFilters((current) => ({ ...current, [name]: value }));

  const resetFilters = () => {
    setFilters({
      workType: "all",
      industryType: "all",
      assignedTo: "all",
      inspectionCycle: "all",
      client: "all",
    });
    setQuickFilter("all");
    gridApiRef.current?.setQuickFilterValues([]);
  };

  const hiddenColumnIds = new Set(props.hiddenColumns || []);
  const engagementColumns = [
    {
      id: "engagementNo",
      header: "Engagement ID",
      accessorKey: "engagementNo",
      size: 118,
      flex: 1.05,
    },
    {
      id: "name",
      header: "Engagement Name",
      accessorKey: "name",
      cell: ({ row }) => (
        <button
          className="btn btn-link p-0 text-start"
          type="button"
          onClick={() =>
            props.onOpenEngagement
              ? props.onOpenEngagement(row.original)
              : navigate(`/engagements/${row.original.id}/preview`)
          }
        >
          {row.original.name}
        </button>
      ),
      size: 195,
      flex: 1.7,
    },
    ...(props.showInspectionCycleColumn
      ? [
          {
            id: "inspectionCycle",
            header: "Inspection Cycle",
            accessorFn: inspectionCycleLabel,
            cell: ({ row, getValue }) =>
              Number(row.original.inspectionCycleId) ? (
                <button
                  className="btn btn-link p-0 text-start"
                  type="button"
                  onClick={() =>
                    navigate(
                      `/inspections/${row.original.inspectionCycleId}/preview`,
                      { state: { fromPath: "/engagements/list" } }
                    )
                  }
                >
                  {getValue()}
                </button>
              ) : (
                <span className="text-muted">{getValue()}</span>
              ),
            size: 190,
            flex: 1.35,
          },
        ]
      : []),
    {
      id: "clientFirm",
      header: "Client / Firm",
      accessorFn: (row) =>
        row.client?.clientName ||
        row.client?.name ||
        row.clientName ||
        row.branchDetail?.name ||
        "—",
      size: 140,
      flex: 1.35,
      cell: ({ row }) => clientFirmTemplate(row.original),
    },
    {
      id: "workType",
      header: "Work Type",
      accessorFn: (row) => row.workType?.name || "",
      size: 102,
      flex: 0.9,
    },
    {
      id: "industryType",
      header: "Industry Type",
      accessorFn: (row) =>
        row.industryType?.name ||
        row.client?.industryType?.name ||
        row.industryTypeName ||
        row.client?.industry ||
        row.client?.industryName ||
        "—",
      size: 120,
      flex: 1,
    },
    {
      id: "actions",
      header: "Actions",
      accessorFn: () => "",
      enableSorting: false,
      enableColumnFilter: false,
      enableExport: false,
      size: 185,
      minSize: 185,
      flex: 0,
      cell: ({ row }) => actionTemplate(row.original),
    },
  ].filter((column) => !hiddenColumnIds.has(column.id));


  if (engagementImportOpen && currentUser && !isEngagementMember) {
    return (
      <DataImportWizardPage
        presentation="page"
        closeAction={closeEngagementImport}
        initialImportType="engagement"
        initialInspectionCycleId={props.dataId}
        cycle={props.cycle}
        onImportStarted={() => {
          SuccessNotify(
            "Engagement import started. Records will appear as processing completes."
          );
        }}
      />
    );
  }

  return (
    <React.Fragment>
      <div
        className={(`page-content engagement-list-page${
          props.cycle ? " engagement-list-page--cycle" : ""
        }${props.embedded ? " engagement-list-page--embedded" : ""}`) + " piers-page"}
      >
        {/*<Breadcrumbs title="Aarna" breadcrumbItem="Tasks" enableAction={true} actionName="New Task" onClick={newTask}></Breadcrumbs>*/}
        <div className="engagement-page-header piers-page-header">
          {props.cycle && !props.embedded && (
            <div className="engagement-cycle-context">
              <div className="engagement-cycle-context__name">
                <Link to="/inspections/list">Inspection Cycles</Link>
                <button
                  type="button"
                  onClick={props.onViewCycle}
                  title="View Cycle Details"
                >
                  {props.cycle.projectTitle ||
                    props.cycle.title ||
                    props.cycle.name ||
                    props.cycle.projectNo}
                </button>
              </div>
              <div className="engagement-cycle-context__id">
                <span>Cycle ID</span>
                <strong>{props.cycle.projectNo || "—"}</strong>
              </div>
            </div>
          )}
          <div className="engagement-page-heading">
            <h2 className="piers-page-title">Engagements</h2>
            <p>Select a summary card to explore engagements, then open an engagement to continue.</p>
          </div>
          <div className="engagement-page-actions">
            <Button
              aria-label="Refresh engagements"
              className="refresh-engagements piers-refresh-button"
              onClick={loadData}
              title="Refresh engagements"
              type="button"
            >
              <i className="bx bx-refresh" /> Refresh
            </Button>
            {!isEngagementMember && (
              <>
                <Button
                  aria-label="Import engagements"
                  className="import-engagements"
                  data-onboarding-target="inspection"
                  onClick={() => setEngagementImportOpen(true)}
                  title="Import engagements"
                  type="button"
                >
                  <i className="bx bx-upload" /> Import Engagements
                </Button>
                <Button
                  type="button"
                  className="create-engagement"
                  data-onboarding-target="engagements"
                  onClick={newEngagement}
                >
                  <i className="bx bx-plus"></i> New Engagement
                </Button>
              </>
            )}
          </div>
        </div>

        {!props.embedded && (
          <section className="engagement-summary" aria-label="Engagement summary">
            {summaryItems.map(([key, icon, tone, label, count, note]) => (
              <button
                key={key}
                type="button"
                className={`engagement-summary__card engagement-summary__card--${tone}`}
                aria-pressed={quickFilter === key}
                aria-controls="engagement-results"
                onClick={() => selectSummary(key)}
              >
                <i className={`bx ${icon}`} aria-hidden="true" />
                <span><b>{label}</b><strong>{gridLoading ? "—" : count}</strong><small>{note}</small></span>
                <i className="bx bx-chevron-right engagement-summary__chevron" aria-hidden="true" />
              </button>
            ))}
          </section>
        )}

        <section className="engagement-workspace">
          <div className="engagement-list-toolbar">

          </div>
          <div id="engagement-results" className="engagement-results-heading">
            <div aria-live="polite" role="status">
              <h3>{props.embedded ? "Engagements" : selectedSummary?.[3]} ({visibleEngagementRows.length})</h3>
              <div className="engagement-results-guidance">
                <p>Open an engagement name to view its details and next steps.</p>
                {(quickFilter !== "all" || Object.values(filters).some((value) => value !== "all")) && (
                  <button type="button" className="filter-reset" onClick={resetFilters}>Show all engagements</button>
                )}
              </div>
            </div>
            <div className="engagement-results-help" role="note" aria-label="Grid action help">
              <i className="bx bx-info-circle" aria-hidden="true" />
              <p><strong>Preview Cycle</strong> opens the linked inspection cycle.<br />Use the <strong>three-dot menu (⋮)</strong> to view activities{!isEngagementMember && ", edit or delete the engagement"}.</p>
            </div>
          </div>
          <Row className="g-0 engagement-grid-row">
            <Col xl={12}>
              <div className="engagement-grid-wrap">
                <CustomDataGrid
 filterContent={<section
              className="engagement-filter-panel"
              aria-label="Engagement filters"
            >
              <div
                className={`engagement-filter-panel__fields${
                  props.showInspectionCycleColumn
                    ? " engagement-filter-panel__fields--register"
                    : ""
                }`}
              >
                {props.showInspectionCycleColumn ? (
                  <>
                    <label>
                      <span>Inspection Cycle</span>
                      <select
                        value={filters.inspectionCycle}
                        onChange={(event) =>
                          updateFilter("inspectionCycle", event.target.value)
                        }
                      >
                        <option value="all">All Inspection Cycles</option>
                        <option value="unassigned">Unassigned</option>
                        {filterOptions.inspectionCycles.map((cycle) => (
                          <option key={cycle.value} value={cycle.value}>
                            {cycle.label}
                          </option>
                        ))}
                      </select>
                    </label>
                    <label>
                      <span>Client / Firm</span>
                      <select
                        value={filters.client}
                        onChange={(event) =>
                          updateFilter("client", event.target.value)
                        }
                      >
                        <option value="all">All Clients / Firms</option>
                        {filterOptions.clients.map((client) => (
                          <option key={client} value={client}>
                            {client}
                          </option>
                        ))}
                      </select>
                    </label>
                    <label>
                      <span>Work Type</span>
                      <select
                        value={filters.workType}
                        onChange={(event) =>
                          updateFilter("workType", event.target.value)
                        }
                      >
                        <option value="all">All Work Types</option>
                        {filterOptions.workTypes.map((workType) => (
                          <option key={workType} value={workType}>
                            {workType}
                          </option>
                        ))}
                      </select>
                    </label>
                    <label>
                      <span>Industry Type</span>
                      <select
                        value={filters.industryType}
                        onChange={(event) =>
                          updateFilter("industryType", event.target.value)
                        }
                      >
                        <option value="all">All Industry Types</option>
                        {filterOptions.industries.map((industry) => (
                          <option key={industry} value={industry}>
                            {industry}
                          </option>
                        ))}
                      </select>
                    </label>
                  </>
                ) : (
                  <>
                    {props.embedded && (
                      <label>
                        <span>Work Type</span>
                        <select
                          value={filters.workType}
                          onChange={(event) =>
                            updateFilter("workType", event.target.value)
                          }
                        >
                          <option value="all">All Work Types</option>
                          {filterOptions.workTypes.map((workType) => (
                            <option key={workType} value={workType}>
                              {workType}
                            </option>
                          ))}
                        </select>
                      </label>
                    )}
                    {props.embedded && (
                      <label>
                        <span>Industry Type</span>
                        <select
                          value={filters.industryType}
                          onChange={(event) =>
                            updateFilter("industryType", event.target.value)
                          }
                        >
                          <option value="all">All Industry Types</option>
                          {filterOptions.industries.map((industry) => (
                            <option key={industry} value={industry}>
                              {industry}
                            </option>
                          ))}
                        </select>
                      </label>
                    )}
                    <label>
                      <span>Assigned To</span>
                      <select
                        value={filters.assignedTo}
                        onChange={(event) =>
                          updateFilter("assignedTo", event.target.value)
                        }
                      >
                        <option value="all">All Assignees</option>
                        <option value={CURRENT_USER_FILTER}>
                          Assigned to Me
                        </option>
                        {filterOptions.assignees.map((assignee) => (
                          <option key={assignee} value={assignee}>
                            {assignee}
                          </option>
                        ))}
                      </select>
                    </label>
                  </>
                )}
              </div>
              <div className="engagement-filter-panel__actions">
                <button
                  type="button"
                  className="engagement-reset"
                  onClick={resetFilters}
                >Clear</button>
              </div>
            </section>}

                  data={visibleEngagementRows}
                  loading={gridLoading}
                  emptyState={{
                    title: props.dataId
                      ? "Add engagements to this Inspection Cycle"
                      : "No engagements available",
                    icon: "bx-folder-open",
                    error: gridError,
                    onRetry: loadData,
                    description: isEngagementMember
                      ? "Your assigned engagements will appear here. Contact your firm administrator or review manager for an assignment."
                      : props.dataId
                      ? "Create an engagement or import a workbook, then prepare its team, scope and checklists for review."
                      : "Select an Inspection Cycle to add engagements and begin preparation.",
                    filtered:
                      tasks.length > 0 ||
                      quickFilter !== "all" ||
                      Object.values(filters).some((value) => value !== "all"),
                    onReset: resetFilters,
                    onAction:
                      !isEngagementMember && props.dataId
                        ? () => setNewTaskOpen(true)
                        : undefined,
                    actionLabel: "Create Engagement",
                    onSecondary:
                      !isEngagementMember && props.dataId
                        ? () => setEngagementImportOpen(true)
                        : undefined,
                    secondaryLabel: "Import Engagements",
                    helpHref: "/piers/getting-started",
                  }}
                  columns={engagementColumns}
                  apiRef={gridApiRef}
                  fileName="engagements"
                  recordLabel="engagements"
                  showToolbar={false}
                  checkboxSelection={false}
                  rowHeight={68}
                  columnHeaderHeight={56}
                  gridSx={{
                    "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: "#ffffff !important",
                      borderBottom: "1px solid #e7ebf2",
                    },
                    "& .MuiDataGrid-columnHeader, & .MuiDataGrid-columnHeader--sortable":
                      {
                        backgroundColor: "#ffffff !important",
                        color: "#52627f",
                      },
                    "& .MuiDataGrid-columnHeaderTitle": {
                      color: "#52627f",
                      fontSize: 12,
                      fontWeight: 700,
                      letterSpacing: ".2px",
                    },
                    "& .MuiDataGrid-columnSeparator": { color: "#e7ebf2" },
                    "& .MuiDataGrid-cell": {
                      fontSize: 13,
                      borderBottomColor: "#edf0f5",
                      color: "#273957",
                    },
                    "& .MuiDataGrid-row": { minHeight: "68px !important" },
                    "& .MuiDataGrid-cellCheckbox, & .MuiDataGrid-columnHeaderCheckbox":
                      { color: "#aab6ca" },
                    "& .MuiDataGrid-footerContainer, & .MuiDataGrid-footerContainer .MuiTypography-root":
                      { fontSize: 14, borderTopColor: "#e7ebf2" },
                  }}
                  initialPageSize={15}
                />
              </div>
            </Col>
          </Row>
        </section>
        <NewEngagementModal
          isOpen={newTaskOpen}
          initialInspectionCycleId={props.dataId}
          onCancel={onTaskClose}
          onSaved={onTaskClose}
        />

        <Offcanvas
          backdrop="static"
          className="engagement-data-preparation-drawer"
          direction="end"
          isOpen={Boolean(dataPreparationAssignmentEngagement)}
          toggle={closeDataPreparationAssignment}
        >
          <OffcanvasHeader
            toggle={closeDataPreparationAssignment}
            className="canvasHeader"
          >
            <div className="data-preparation-assignment__header-copy">
              <b>Assign for Preparation</b>
              <small>
                Choose the current owner responsible for completing engagement
                data.
              </small>
            </div>
          </OffcanvasHeader>
          <OffcanvasBody>
            <div className="data-preparation-assignment__summary">
              <strong>
                {dataPreparationAssignmentEngagement?.name ||
                  dataPreparationAssignmentEngagement?.engagementNo}
              </strong>
              <span>
                {dataPreparationAssignmentEngagement?.client?.clientName ||
                  dataPreparationAssignmentEngagement?.clientName ||
                  "No client selected"}
              </span>
            </div>
            <label className="data-preparation-assignment__field">
              <span>
                Assign to User <b>*</b>
              </span>
              <Select
                classNamePrefix="data-preparation-user-select"
                isClearable
                isDisabled={
                  dataPreparationUsersLoading || dataPreparationSaving
                }
                isLoading={dataPreparationUsersLoading}
                isSearchable
                noOptionsMessage={() => "No active users found"}
                onChange={(option) =>
                  setDataPreparationAssigneeId(
                    option ? String(option.value) : ""
                  )
                }
                options={dataPreparationUsers.map((user) => ({
                  value: user.id,
                  label: `${user.fullName}${
                    user.role?.name ? ` — ${user.role.name}` : ""
                  }`,
                }))}
                placeholder={
                  dataPreparationUsersLoading
                    ? "Loading users..."
                    : "Search users by name or role"
                }
                value={
                  dataPreparationUsers
                    .filter(
                      (user) => String(user.id) === dataPreparationAssigneeId
                    )
                    .map((user) => ({
                      value: user.id,
                      label: `${user.fullName}${
                        user.role?.name ? ` — ${user.role.name}` : ""
                      }`,
                    }))[0] || null
                }
              />
              <small>
                Any active user in this firm, including QM and Firm Admin, can
                be assigned.
              </small>
            </label>
            <label className="data-preparation-assignment__field">
              <span>
                Message / instructions <em>Optional</em>
              </span>
              <textarea
                value={dataPreparationMessage}
                maxLength={500}
                rows={5}
                disabled={dataPreparationSaving}
                onChange={(event) =>
                  setDataPreparationMessage(event.target.value)
                }
                placeholder="Add instructions, context, or a due-date reminder for the assignee..."
              />
              <small>
                {dataPreparationMessage.length}/500 characters. This is included
                in the assignee's notification and engagement activity.
              </small>
            </label>
          </OffcanvasBody>
          <div className="canvasFooter data-preparation-assignment__footer">
            <Button type="button" onClick={closeDataPreparationAssignment}>
              Cancel
            </Button>
            <Button
              color="primary"
              className="btn btn-primary"
              type="button"
              disabled={
                !dataPreparationAssigneeId ||
                dataPreparationUsersLoading ||
                dataPreparationSaving
              }
              onClick={saveDataPreparationAssignment}
            >
              {dataPreparationSaving
                ? "Assigning..."
                : "Assign for Preparation"}
            </Button>
          </div>
        </Offcanvas>

        <Offcanvas
          backdrop="static"
          className="engagement-activities-drawer"
          direction="end"
          isOpen={Boolean(activitiesEngagement)}
          toggle={() => setActivitiesEngagement(null)}
        >
          <OffcanvasHeader
            toggle={() => setActivitiesEngagement(null)}
            className="canvasHeader"
          >
            <b>Engagement Activities</b>
          </OffcanvasHeader>
          <OffcanvasBody>
            {activitiesEngagement && (
              <EngagementActivities
                engagementId={activitiesEngagement.id}
                engagementName={
                  activitiesEngagement.name || activitiesEngagement.engagementNo
                }
              />
            )}
          </OffcanvasBody>
        </Offcanvas>

        <Modal
          isOpen={Boolean(sendForReviewEngagement)}
          toggle={closeSendForReview}
        >
          <ModalHeader toggle={closeSendForReview} className="canvasHeader">
            Send for Review
          </ModalHeader>
          <ModalBody>
            <div>
              <p>
                This will create the configured review checklist and send{" "}
                <strong>
                  {sendForReviewEngagement?.name ||
                    sendForReviewEngagement?.engagementNo}
                </strong>{" "}
                to its assigned reviewer.
              </p>
              {reviewReadinessLoading ? (
                <p className="text-muted mb-0">Checking review readiness…</p>
              ) : reviewReadinessIssues.length > 0 ? (
                <div className="alert alert-danger mb-0" role="alert">
                  <strong>
                    Resolve these blocking issues before sending for review:
                  </strong>
                  <ul className="mb-0 mt-2 ps-3">
                    {reviewReadinessIssues.map((issue) => (
                      <li key={issue}>{issue}</li>
                    ))}
                  </ul>
                </div>
              ) : (
                <div className="alert alert-success mb-0" role="status">
                  This engagement is ready to send for review.
                </div>
              )}
            </div>
          </ModalBody>
          <ModalFooter className="canvasFooter">
            {!reviewReadinessLoading && reviewReadinessIssues.length > 0 && (
              <Button
                type="button"
                onClick={() => openReviewAssignment(sendForReviewEngagement)}
              >
                Edit Preparation Details
              </Button>
            )}
            <Button
              color="primary"
              className="btn btn-primary"
              type="button"
              onClick={sendForReview}
              disabled={
                reviewReadinessLoading || reviewReadinessIssues.length > 0
              }
            >
              Send for Review
            </Button>
            <Button
              color="secondary"
              className="btn primary"
              type="button"
              onClick={closeSendForReview}
            >
              Close
            </Button>
          </ModalFooter>
        </Modal>

        <Modal
          isOpen={Boolean(engagementPendingDeletion)}
          toggle={() => setEngagementPendingDeletion(null)}
        >
          <ModalHeader
            toggle={() => setEngagementPendingDeletion(null)}
            className="canvasHeader"
          >
            Delete Engagement
          </ModalHeader>
          <ModalBody>
            <div className="alert alert-danger" role="alert">
              <strong>This action cannot be undone.</strong>
            </div>
            <p>
              Permanently delete{" "}
              <strong>
                {engagementPendingDeletion?.name ||
                  engagementPendingDeletion?.engagementNo}
              </strong>
              ?
            </p>
            <p className="mb-0 text-muted">
              Its draft checklist selections, documents, activities, comments,
              and related tasks will also be removed. Engagements already sent
              for review cannot be deleted.
            </p>
          </ModalBody>
          <ModalFooter className="canvasFooter">
            <Button
              color="secondary"
              className="btn primary"
              type="button"
              onClick={() => setEngagementPendingDeletion(null)}
            >
              Cancel
            </Button>
            <Button
              color="danger"
              className="btn btn-danger"
              type="button"
              onClick={confirmDeleteEngagement}
            >
              Delete Engagement
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </React.Fragment>
  );
};

export default EngagementList;
